import { render, staticRenderFns } from "./RoleIndexView.vue?vue&type=template&id=23a88d64"
import script from "./RoleIndexView.vue?vue&type=script&lang=js"
export * from "./RoleIndexView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports